import React, { ReactNode } from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import { originalIcons } from '@shared/components/icons/icons'
import makeStyles from '@mui/styles/makeStyles'

type Props = {
  text: string
  tooltipText?: string
  icon: ReactNode
  className?: string
}

export const TooltipText = ({ tooltipText, text, icon, className }: Props) => {
  const classes = useStyles()
  return (
    <Tooltip title={tooltipText} className={className}>
      <Box display="flex" alignItems="center">
        {icon}
        <Typography variant="body2" className={classes.text}>
          {text}
        </Typography>
        <originalIcons.Expand className={classes.icon} />
      </Box>
    </Tooltip>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    text: {
      fontSize: theme.spacing(1.5),
    },
    icon: {
      color: theme.palette.text.secondary,
      fontSize: theme.spacing(2),
    },
  }
})
